<template>
    <div class="competence">

      <!-- POPUP ADD NEW COMPETENCE -->
      <div :class="{'show': popupShow}" class="overlay" @click.self="popupShow = false">
        <div class="popup">
          <span class="title">{{ $t('diagnostic.competence.title') }}</span>
          <div v-show="error_message" class="message error fadeIn">{{ $t('diagnostic.competence.error_message') }}</div>
          <v-text-field
            :label="$t('general.name')"
            v-model="customName"
          ></v-text-field>
          <v-select
            :items="competenceCategories"
            item-text="name"
            item-value="value"
            v-model="selectedCategory"
            :label="$t('general.category')"
          ></v-select>
        <div class="button" @click="addCustomBrand(customName, selectedCategory)">{{ $t('general.add') }}</div>
        </div>
      </div>

      <div class=" sec-title">{{ $t('diagnostic.competence.competence') }}</div>
      <span class="sec-description" v-html="$t('diagnostic.competence.description')"></span>
        <i v-if="sectionDescription">{{sectionDescription}}</i></span>

        <table class="which" cellspacing="0" cellpadding="0">
          <thead>
            <th class="hide"></th>
            <th>{{ $t('diagnostic.competence.definition') }}</th>
            <th>{{ $t('diagnostic.competence.intensity') }} <sub class="no-print">[ 1 ]</sub></th>
            <th width="35%">{{ $t('diagnostic.competence.which') }}</th>
          </thead>
          <tbody>
            <tr>
              <td>{{ $t('diagnostic.competence.competitors.direct.title') }}</td>
              <td class="desc" v-html="$t('diagnostic.competence.competitors.direct.description')"></td>
              <td>
                <select class="intensity" v-model="competenceIntensity.type1" @change="changeBrand = true">
                  <option value=""></option>
                  <option value="1">{{ $t('diagnostic.competence.high') }}</option>
                  <option value="2">{{ $t('diagnostic.competence.medium') }}</option>
                  <option value="3">{{ $t('diagnostic.competence.low') }}</option>
                </select>
              </td>
              <td>

                <span v-for="(item, index) in currentCompetence" v-if="item.type == 1" class="brand">{{item.name}}
                  <v-icon @click="del(item)" class="delete">delete</v-icon>
                </span>

                <div class="no-print">
                  <span class="label">{{ $t('general.add') }}: </span>
                  <v-layout wrap>
                    <v-flex lg11 md10>
                      <v-autocomplete
                        style="margin-top: 0px; padding-top: 0px;"
                        color="#004412"
                        ref="competidor1"
                        :no-data-text="noResultsText"
                        :items="Object.values(brands[1]).filter((brand)=> !Object.keys(currentCompetence).includes(brand.brand_id))"
                        item-text="name"
                        item-value="brand_id"
                        hide-selected
                        @change="addBrand($event, 1)"
                      >
                      </v-autocomplete>
                    </v-flex>

                    <v-flex lg1 md2>
                      <div class="add" @click="showPopup(1)"><v-icon class="icon">add</v-icon></div>
                    </v-flex>
                  </v-layout>
                </div>
              </td>
            </tr>
            <tr>
              <td>{{ $t('diagnostic.competence.competitors.qsr.title') }}</td>
              <td class="desc" v-html="$t('diagnostic.competence.competitors.qsr.description')"></td>
              <td>
                <select class="intensity" v-model="competenceIntensity.type2" @change="changeBrand = true">
                  <option value=""></option>
                  <option value="1">{{ $t('diagnostic.competence.high') }}</option>
                  <option value="2">{{ $t('diagnostic.competence.medium') }}</option>
                  <option value="3">{{ $t('diagnostic.competence.low') }}</option>
                </select>
              </td>
              <td>
                <span v-for="(item, index) in currentCompetence" v-if="item.type == 2" class="brand">{{item.name}}
                  <v-icon @click="del(item)" class="delete">delete</v-icon>
                </span>

                <div class="no-print">
                  <span class="label">{{ $t('general.add') }}: </span>
                  <v-layout wrap>
                    <v-flex lg11 md10>
                      <v-autocomplete
                        style="margin-top: 0px; padding-top: 0px;"
                        color="#004412"
                        ref="competidor2"
                        :no-data-text="noResultsText"
                        :items="Object.values(brands[2]).filter((brand)=> !Object.keys(currentCompetence).includes(brand.brand_id))"
                        item-text="name"
                        item-value="brand_id"
                        hide-selected
                        @change="addBrand($event, 2)"
                      >
                      </v-autocomplete>
                    </v-flex>

                    <v-flex lg1 md2>
                      <div class="add" @click="showPopup(2)"><v-icon class="icon">add</v-icon></div>
                    </v-flex>
                  </v-layout>
                </div>
              </td>
            </tr>
            <tr>
              <td>{{ $t('diagnostic.competence.competitors.coffee.title') }}</td>
              <td class="desc" v-html="$t('diagnostic.competence.competitors.coffee.description')"></td>
              <td>
                <select class="intensity" v-model="competenceIntensity.type3" @change="changeBrand = true">
                  <option value=""></option>
                  <option value="1">{{ $t('diagnostic.competence.high') }}</option>
                  <option value="2">{{ $t('diagnostic.competence.medium') }}</option>
                  <option value="3">{{ $t('diagnostic.competence.low') }}</option>
                </select>
              </td>
              <td>
                <span v-for="(item, index) in currentCompetence" v-if="item.type == 3" class="brand">{{item.name}}
                  <v-icon @click="del(item)" class="delete">delete</v-icon>
                </span>

                <div class="no-print">
                  <span class="label">{{ $t('general.add') }}: </span>

                  <v-layout wrap>
                    <v-flex lg11 md10>
                      <v-autocomplete
                        style="margin-top: 0px; padding-top: 0px;"
                        color="#004412"
                        ref="competidor3"
                        :no-data-text="noResultsText"
                        :items="Object.values(brands[3]).filter((brand)=> !Object.keys(currentCompetence).includes(brand.brand_id))"
                        item-text="name"
                        item-value="brand_id"
                        hide-selected
                        @change="addBrand($event, 3)"
                      >
                      </v-autocomplete>
                    </v-flex>

                    <v-flex lg1 md2>
                      <div class="add" @click="showPopup(3)"><v-icon class="icon">add</v-icon></div>
                    </v-flex>
                  </v-layout>
                </div>
              </td>
            </tr>
            <tr>
              <td>{{ $t('diagnostic.competence.competitors.casual.title') }}</td>
              <td class="desc" v-html="$t('diagnostic.competence.competitors.casual.description')"></td>
              <td>
                <select class="intensity" v-model="competenceIntensity.type4" @change="changeBrand = true">
                  <option value=""></option>
                  <option value="1">{{ $t('diagnostic.competence.high') }}</option>
                  <option value="2">{{ $t('diagnostic.competence.medium') }}</option>
                  <option value="3">{{ $t('diagnostic.competence.low') }}</option>
                </select>
              </td>
              <td>
                <span v-for="(item, index) in currentCompetence" v-if="item.type == 4" class="brand">{{item.name}}
                  <v-icon @click="del(item)" class="delete">delete</v-icon>
                </span>

                <div class="no-print">
                  <span class="label">{{ $t('general.add') }}: </span>

                  <v-layout wrap>
                    <v-flex lg11 md10>
                      <v-autocomplete
                        style="margin-top: 0px; padding-top: 0px;"
                        color="#004412"
                        ref="competidor4"
                        :no-data-text="noResultsText"
                        :items="Object.values(brands[4]).filter((brand)=> !Object.keys(currentCompetence).includes(brand.brand_id))"
                        item-text="name"
                        item-value="brand_id"
                        hide-selected
                        @change="addBrand($event, 4)"
                      >
                      </v-autocomplete>
                    </v-flex>

                    <v-flex lg1 md2>
                      <div class="add" @click="showPopup(4)"><v-icon class="icon">add</v-icon></div>
                    </v-flex>
                  </v-layout>
                </div>
              </td>
            </tr>
            <tr>
              <td>{{ $t('diagnostic.competence.competitors.resto_ieo.title') }}</td>
                <td class="desc" v-html="$t('diagnostic.competence.competitors.resto_ieo.description')"></td>
              <td>
                <select class="intensity" v-model="competenceIntensity.type5" @change="changeBrand = true">
                  <option value=""></option>
                  <option value="1">{{ $t('diagnostic.competence.high') }}</option>
                  <option value="2">{{ $t('diagnostic.competence.medium') }}</option>
                  <option value="3">{{ $t('diagnostic.competence.low') }}</option>
                </select>
              </td>
              <td>
                <span v-for="(item, index) in currentCompetence" v-if="item.type == 5" class="brand">{{item.name}}
                  <v-icon @click="del(item)" class="delete">delete</v-icon>
                </span>

                <div class="no-print">
                  <span class="label">{{ $t('general.add') }}: </span>

                  <v-layout wrap>
                    <v-flex lg11 md10>
                      <v-autocomplete
                        style="margin-top: 0px; padding-top: 0px;"
                        color="#004412"
                        ref="competidor5"
                        :no-data-text="noResultsText"
                        :items="Object.values(brands[5]).filter((brand)=> !Object.keys(currentCompetence).includes(brand.brand_id))"
                        item-text="name"
                        item-value="brand_id"
                        hide-selected
                        @change="addBrand($event, 5)"
                      >
                      </v-autocomplete>
                    </v-flex>

                    <v-flex lg1 md2>
                      <div class="add" @click="showPopup(5)"><v-icon class="icon">add</v-icon></div>
                    </v-flex>
                  </v-layout>
                </div>
              </td>
            </tr>
            <tr>
              <td>{{ $t('diagnostic.competence.competitors.indirecta.title') }}</td>
              <td class="desc" v-html="$t('diagnostic.competence.competitors.indirecta.description')"></td>
              <td>
                <select class="intensity" v-model="competenceIntensity.type0" @change="changeBrand = true">
                  <option value=""></option>
                  <option value="1">{{ $t('diagnostic.competence.high') }}</option>
                  <option value="2">{{ $t('diagnostic.competence.medium') }}</option>
                  <option value="3">{{ $t('diagnostic.competence.low') }}</option>
                </select>
              </td>
              <td>
                <span v-for="(item, index) in currentCompetence" v-if="item.type == 0" class="brand">{{item.name}}
                  <v-icon @click="del(item)" class="delete">delete</v-icon>
                </span>

                <div class="no-print">
                  <span class="label">{{ $t('general.add') }}: </span>

                  <v-layout wrap>
                    <v-flex lg11 md10>
                      <v-autocomplete
                        style="margin-top: 0px; padding-top: 0px;"
                        color="#004412"
                        ref="competidor0"
                        :no-data-text="noResultsText"
                        :items="Object.values(brands[0]).filter((brand)=> !Object.keys(currentCompetence).includes(brand.brand_id))"
                        item-text="name"
                        item-value="brand_id"
                        hide-selected
                        @change="addBrand($event, 0)"
                      >
                      </v-autocomplete>
                    </v-flex>

                    <v-flex lg1 md2>
                      <div class="add" @click="showPopup(0)"><v-icon class="icon">add</v-icon></div>
                    </v-flex>
                  </v-layout>

                  <!-- <select @change="addBrand($event, 0)" :class="{'new': newBrand }">
                    <option></option>
                    <option value="add">Añadir nueva competencia</option>
                    <option v-for="item in brands[0]" v-if="!currentCompetence.hasOwnProperty(item.brand_id)" :value="item.brand_id">{{item.name}}</option>
                  </select> -->
                  <!-- <input type="text" class="custom" ref="custom" :class="{'new': newBrand }" v-on:keyup.enter="addCustomBrand($event, 0);" @blur="newBrand = false"> -->
                  <!-- <v-icon class="add" :class="{'new': newBrand }" @click="newBrand = true; $nextTick(() => $refs.custom.focus())">add</v-icon> -->
                </div>
              </td>
            </tr>
          </tbody>

        </table>
        <div style="display: none;">{{competence}}</div>
        <div :class="{'hidden': !changeBrand}" @click="saveBrand()" class="save no-print">
          {{ $t('general.save_changes') }}
        </div>

      <div class="title subarea">{{ $t('diagnostic.competence.competitors.subarea.title') }}</div>
      <span class="sec-description">{{ $t('diagnostic.competence.competitors.subarea.description') }}</span>
        <table class="comparation" cellspacing="0" cellpadding="0">
          <thead>
            <th></th>
            <th>
              {{ $t('diagnostic.competence.competitors.subarea.service.title') }}
              <span class="description">{{ $t('diagnostic.competence.competitors.subarea.service.description') }}</span>
            </th>
            <th>
              {{ $t('diagnostic.competence.competitors.subarea.price.title') }}
              <span class="description">{{ $t('diagnostic.competence.competitors.subarea.price.description') }}</span>
            </th>
            <th>{{ $t('diagnostic.competence.competitors.subarea.innovation') }}</th>
            <th>{{ $t('diagnostic.competence.competitors.subarea.ambience') }}</th>
            <th>{{ $t('diagnostic.competence.competitors.subarea.promotions') }}</th>
          </thead>
          <tbody>
            <tr v-for="(item, index) in row">
              <td class="company">
                <template v-if="item.brand_id && item.brand_id == -1">
                  <span>{{item.name}}</span>
                  <!--<span v-if="item.brand_id != -1">Eliminar</span>-->
                </template>
                <select v-if="item.brand_id !== -1" v-model="item.brand_id" @change="selectComparator($event, index)">
                  <option :value="false" @click="changeCompare=true"></option>
                  <option v-for="comp in currentCompetence" v-if="comp.brand_id==item.brand_id || !row.hasOwnProperty(comp.brand_id)" :value="comp.brand_id" :selected="{'true': comp.brand_id == item.brand_id}">{{comp.name}}</option>
                </select>
              </td>
              <td v-for="(subitem, subindex) in item.features">
                <div class="tooltip">
                  <span class="val rate" v-if="item.brand_id">{{item.features[subindex]}}</span>
                  <div class="tooltiptext" v-if="item.brand_id">
                    <input type="number" v-for="options in options" :id="'star'+index+subindex"  v-model="item.features[subindex]">{{options.value}}</input>
                    <label class="option" v-for="options in options" :class="{'checked': options.value <= item.features[subindex] }" @click="rate(options.value, $event, index, subindex)" :for="'star'+index+subindex"></label>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div :class="{'hidden': !changeCompare}" @click="saveCompare()" class="save no-print">
          {{ $t('general.save_changes') }}
        </div>
      </div>
    </div>
</template>

<script>
import i18n from '@/i18n';

export default {
  data () {
    return {

      options: [{
        value: 5
      },
      {
        value: 4
      },
      {
        value: 3
      },
      {
        value: 2
      },
      {
        value: 1
      }],

      columns: [{
        service: ''
      },
      {
        relation: ''
      },
      {
        innovation: ''
      },
      {
        ambient: ''
      },
      {
        promotion: ''
      }],

      changeBrand: false,
      changeCompare: false,

      data: undefined,

      currentCompetence: {},

      brandModel: this.brand,

      popupShow: false,
      error_message: false,

      noResultsText: this.$t('diagnostic.competence.no_results'),

      customName: '',
      selectedCategory: '',

      competenceCategories: [
        { name: 'Competidores directos', value: 1 },
        { name: 'Otros QSR', value: 2 },
        { name: 'Cafeterías', value: 3 },
        { name: 'Casual Restaurante', value: 4 },
        { name: 'Resto IEO', value: 5 },
        { name: 'Indirecta', value: 0 }
      ]
    }
  },
  computed: {
    sectionDescription() {
      var section = this.$store.getters['locations/getDiagnosticDescriptions']['competence']
      if (section && section.description) {
        return section.description;
      } else return false;
    },

    selectedLocation () {
      return this.$store.getters['locations/getSelectedLocation']
    },

    /* TABLA COMPETENCIA */
    brands () {
      return this.$store.getters['locations/getAllCompetence']
    },

    /* "INTENSIDAD" Tabla Competencia */
    competenceIntensity () {
      var data = this.$store.getters['locations/getCompetenceData']
      if (typeof data === 'object') {
        data = { type0: '', type1: '', type2: '', type3: '', type4: '', type5: '' }
      } else if (typeof data === 'string') {
        data = JSON.parse(this.$store.getters['locations/getCompetenceData'])
      }
      return data
    },

    /* "CUALES" Tabla Competencia */
    competence () {
      return this.currentCompetence
    },

    /* TABLA COMPARATIVA */
    comparation () {
      return this.$store.getters['locations/getComparation']
    },

    /* Filas de la tabla Comparativa */
    row () {
      var data = Object.values(this.currentCompetence)

      // Construccion del objeto base
      var row = {
        0: {
          'brand_id': -1,
          'name': "McDonald's",
          'features': this.$store.getters['locations/getComparation'] != null ? this.$store.getters['locations/getComparation'] : { service: '', relation: '', innovation: '', ambient: '', promotion: '' },
          'status': 2,
          'order': 1
        },
        1: {
          'brand_id': false,
          'name': false,

          'features': { service: '', relation: '', innovation: '', ambient: '', promotion: '' },
          'order': 2
        },
        2: {
          'brand_id': false,
          'name': false,
          'features': { service: '', relation: '', innovation: '', ambient: '', promotion: '' },
          'order': 3
        },
        3: {
          'brand_id': false,
          'name': false,
          'features': { service: '', relation: '', innovation: '', ambient: '', promotion: '' },
          'order': 4
        }
      }

      function compare (a, b) {
        if (a.order < b.order) {
          return -1
        }
        if (a.order > b.order) {
          return 1
        }
        return 0
      }

      var counter = 1
      var sortable = []

      for (var item in data) {
        if (counter < 4) {
          if (data[item].status == '2') {
            data[item].order = row[counter].order
            delete Object.assign(row, { [data[item].brand_id]: row[counter] })[counter]
            row[data[item].brand_id] = data[item]
            counter++
          }
        }
      }

      for (var item in row) {
        sortable.push([item, row[item]])
      }

      sortable.sort(function (a, b) {
        return a[1].order - b[1].order
      })

      var objSorted = {}
      sortable.forEach(function (item) {
        objSorted[item[0]] = item[1]
      })

      return objSorted
    },

    brand () {
      var data = this.competenceIntensity

      if (data != null && typeof (data) !== 'object') {
        var result = JSON.parse(data)
        return this.brandModel = result.brand
      } else {
        var brand = {
          type0: [],
          type1: [],
          type2: [],
          type3: [],
          type4: [],
          type5: []
        }
      }
      for (var item in this.competence) {
        var element = {}
        switch (this.competence[item].type) {
          case '1':
            element.brand_id = this.competence[item].brand_id
            element.name = this.competence[item].name
            brand.type1.push(element)
            break
          case '2':
            element.brand_id = this.competence[item].brand_id
            element.name = this.competence[item].name
            brand.type2.push(element)
            break
          case '3':
            element.brand_id = this.competence[item].brand_id
            element.name = this.competence[item].name
            brand.type3.push(element)
            break
          case '4':
            element.brand_id = this.competence[item].brand_id
            element.name = this.competence[item].name
            brand.type3.push(element)
            break
          case '5':
            element.brand_id = this.competence[item].brand_id
            element.name = this.competence[item].name
            brand.type3.push(element)
            break
          case '0':
            element.brand_id = this.competence[item].brand_id
            element.name = this.competence[item].name
            brand.type0.push(element)
            break
        }
      }
      return this.brandModel = brand
    }
  },
  methods: {

    /* COMPETENCIA */
    del (brand) {
      var self = this
      this.$popup.confirm(
        this.$t('diagnostic.competence.popup.title'),
        this.$t('diagnostic.competence.popup.description'),
        this.$t('general.delete'),
        this.$t('general.cancel'),
        function () {
          self.$delete(self.currentCompetence, brand.brand_id)
          self.changeBrand = true
        }
      )
    },

    addBrand (event, type) {
      var brand = this.brands[type][event]
      this.$set(this.currentCompetence, brand.brand_id, brand)
      this.changeBrand = true
    },

    showPopup (type) {
      this.popupShow = true
      this.selectedCategory = type
    },

    addCustomBrand (name, type) {
      if (name != '') {
        var self = this
        this.$store.dispatch('locations/addBrand', { name: name.toUpperCase(), type: type, restaurant_id: this.$store.getters['locations/getSelectedLocation'].id }).then(function () {
          var idx = self
          self.$store.dispatch('locations/loadCompetence', self.$store.getters['locations/getSelectedLocation'].id).then(function () {
            var result = Object.values(idx.competence).find(obj => {
              return obj.name == name
            })
            idx.$set(idx.currentCompetence, result.id, result)
          })
        })
        this.saveBrand()
        this.popupShow = false
      } else {
        this.error_message = true
      }
    },

    saveBrand () {
      var aData = {}
      aData.competence = {}
      aData.restaurant_id = this.$store.getters['locations/getSelectedLocation'].id
      aData.intensity = JSON.stringify(this.competenceIntensity)

      var brands = []
      for (var item in this.currentCompetence) {
        brands.push(item)
      }
      aData.competence = JSON.stringify(brands)

      var self = this
      this.$store.dispatch('locations/updateCompetenceData', aData).then(function () {
        self.loadComponentData()
        self.changeBrand = false
      })
    },

    /* COMPARACION */
    rate (option, e, index, subindex) {
      var target = e.currentTarget.parentNode.parentNode.querySelector('.val')
      target.className = 'val rate'
      this.row[index].features[subindex] = parseInt(option)
      // target.innerText = option;
      this.changeCompare = true
    },

    selectComparator (event, index) {
      var brand = this.currentCompetence[event.target.value]
      if (brand == undefined) {
        this.changeCompare = true
      } else {
        brand.features = { service: '', relation: '', innovation: '', ambient: '', promotion: '' }
        this.$delete(this.row, brand.brand_id)
        this.$delete(this.row, index)
        this.$set(this.row, brand.brand_id, brand)
        // var idx = "features";
        // this.$set(this.row[Object.keys(this.row)[index]], idx, brand.features);
        this.changeCompare = true
      }
    },

    saveCompare () {
      var aData = {}
      aData.mcd = this.row[0]
      if (this.row[Object.keys(this.row)[1]].brand_id != false) {
        aData.rest1 = this.row[Object.keys(this.row)[1]]
      }
      if (this.row[Object.keys(this.row)[2]].brand_id != false) {
        aData.rest2 = this.row[Object.keys(this.row)[2]]
      }
      if (this.row[Object.keys(this.row)[3]].brand_id != false) {
        aData.rest3 = this.row[Object.keys(this.row)[3]]
      }
      aData.restaurant_id = this.$store.getters['locations/getSelectedLocation'].id
      var self = this
      this.$store.dispatch('locations/updateComparation', aData).then(function () {
        self.changeCompare = false
      })
    },

    /* GENERALES */
    checkChangesBeforeExit: function () {
      if (this.changeCompare || this.changeBrand) {
        return false
      } else return true
    },

    loadComponentData () {
      var self = this
      this.$store.dispatch('locations/loadAllCompetence', this.$store.getters['locations/getSelectedLocation'].id)
      this.$store.dispatch('locations/loadCompetence', this.$store.getters['locations/getSelectedLocation'].id).then(function () {
        var data = self.$store.getters['locations/getCompetence']
        self.currentCompetence = (data.length == 0) ? {} : data
      })
      this.$store.dispatch('locations/loadComparation', this.$store.getters['locations/getSelectedLocation'].id)
      this.$store.dispatch('locations/loadCompetenceData', this.$store.getters['locations/getSelectedLocation'].id).then(function () {
        self.brand
        self.changeBrand = false
      })
    }
  },
  watch: {
    selectedLocation () {
      if (this.selectedLocation == undefined) {
        this.$store.getters['locations/getSelectedLocation']
      }
      this.loadComponentData()
    },

    popupShow () {
      if (this.popupShow == false) {
        this.selectedCategory = ''
        this.customName = ''
        this.error_message = false
      }
    }
  },

  created () {
    this.loadComponentData()
  },

  beforeRouteLeave (to, from, next) {
    next()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  /* POPUP ADD NEW COMPETENCE */
  .overlay {
    display: none;
    position: fixed;
    z-index: 10;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.2);
    transition: opacity 500ms;
    visibility: hidden;
    opacity: 0;

    &.show {
      display: unset;
      visibility: visible;
      opacity: 1;
    }

    .popup {
      visibility: visible;
      position: fixed;
      z-index: 50;
      background-color: white;
      top: calc(55% - 250px);
      width: 50%;
      left: 68%;
      margin-left: -42.5%;
      height: fit-content;
      padding: 30px;
      border-radius: 5px;

      .button {
        background-color: var(--main_color);
        padding: 10px 20px;
        margin: 0 auto;
        width: fit-content;
        font-size: 15px;
        border-radius: 5px;
        cursor: pointer;
      }

    }
  }

  .sec-title {
    background: var(--main_color);
    color: var(--dark_color);
    display: inline-block;
    text-align: center;
    font-size: 19px;
    font-family: Speedee-Bold;
    margin: 0;
    margin-top: 5px;
    padding: 0px 10px;
    z-index: 1;
  }

  .sec-description {
    display: block;
    color: #999;
    margin-bottom: 40px;
  }

  .title {
    width: auto;

    &.subarea {
      margin-bottom: 15px;
      font-size: 18px !important;
      font-weight: bold;
      margin-top: 30px;
    }
  }

  .competence {
    oveflow: hidden;

      .intensity {
        outline: none;
        padding: 8px;
        display: inline-block;
        border-bottom: 1px solid #ababab;

        td & {
          background-color: yellow
        }

        .options {
          border: 1px solid black;
          border-radius: 8px;
          width: fit-content;
          margin: 10px auto;
          overflow: hidden;

          .option {
            display: inline-block;
            line-height: 1.5;
            padding: 7px 20px;
            cursor: pointer;

            &.checked, &:hover {
              background-color: var(--main_color)
            }

            &.checked {
              color: black;
              font-weight: bold;
            }
          }
        }
      }

      .which {
        margin: 20px auto 0px;
        border-color: white;
        width: 95%;

        .hide {
          visibility: hidden !important;
          opacity: 0 !important;
        }

        thead {

          th {
            background-color: transparent;
            border-bottom: 1px solid var(--main_color);
            height: 50px;
            text-transform: uppercase;
            padding: 0px 10px;

            .description {
              display: block;
              text-transform: none;
              font-weight: normal;
              font-size: 14px;
            }
          }
        }

        tbody {
          //background-color: var(--main_color);
        }
        tr {
          background-color: rgba(255,255,255,0.5);
          height: 50px;
        }

        tr:nth-child(odd) {
          background-color: rgba(255,255,255,0.7);
        }

        td {
          text-transform: uppercase;
          font-weight: bold;
          padding: 10px 10px;
          text-align: left;
          width: 10%;
          text-align: center;
          border-bottom: 1px solid #ddd;
          text-align: left;

          .brand {
            margin: 6px 1.5%;
            cursor: pointer;
            display: inline-block;
            background: url('/img/marker.svg') no-repeat left 5px center;
            background-size: 15px;
            background-color: #eee;
            padding: 6px;
            border-radius: 3px;
            padding-left: 25px;
            width: 47%;
            max-height: 50px;
            text-overflow: ellipsis;
            overflow: hidden;

            &:hover {
              .delete {
                display: inline-block;
              }
            }
          }

          .add{
            color: white;
            cursor: pointer;
            text-align: center;
            margin-left: 5px;
            margin: 0 auto;
            border-radius: 30px;
            background-color: #eee;
            width: 30px;
            height: 30px;
            line-height: 37px;

            &:hover {
              .icon {
              color: #555;
              }
            }

            .icon {
              color: #777;
            }

            &.new {
              display: none;
            }
          }

          .custom {
            outline: none;
            padding: 8px;
            display: inline-block;
            border-bottom: 1px solid #ababab;
            width: calc( 95% - 100px );
            display: none;

            &.new {
              display: inline-block;
            }
          }

          .delete{
            font-size: 13px;
            padding: 3px;
            background-color: #ff5252;
            color: white;
            border-radius: 100%;
            cursor: pointer;
            margin-left: 5px;
            display: none;
          }

          &.desc {
            font-size: 13px;
            font-weight: lighter;
            line-height: 14px;
            text-transform: none;
            text-align: left;

            .description {
              display: block;
              text-transform: none;
              font-weight: normal;
              font-size: 12px;
              margin-top: 5px;
              color: #999;
            }
          }

        }

        td:last-child {
          padding: 10px 5px;

          .label {
            width: 100px;
            line-height: 16px;
            font-weight: lighter;
            color: #999;
            text-transform: none;
            display: inline-block;
            padding-top: 5px;
          }

          select {
            outline: none;
            padding: 8px;
            display: inline-block;
            border-bottom: 1px solid #ababab;
            width: calc( 95% - 100px );

            &.new {
              display: none;
            }
          }
        }
      }

      .comparation {
        margin: 0 auto;
        //background-color: var(--main_color);
        border-color: white;

        th {
          background-color: transparent;
          border-bottom: 1px solid var(--main_color);
          height: 50px;
          line-height: 16px;
          text-transform: uppercase;
          padding: 10px 10px;

          .description{
            margin-top: 10px;
            font-size: 12px;
            line-height: 12px;
            display: block;
            color: #666;
            font-weight: lighter;
            text-transform: none;
          }
        }

        select {
          padding: 8px;
          width: 170px;
          border: 1px solid #ccc;
          /*border-bottom: 1px solid #999;*/
        }

        tr {
          background-color: rgba(255,255,255,0.5);
          height: 60px;
        }

        tr:nth-child(odd) {
          background-color: rgba(255,255,255,0.7);
        }

        td:first-child {
          font-weight: bold;
          padding: 0px 5px;
          text-align: left;
          width: 10%;
          text-align: center !important;

          .description {
            display: block;
            text-transform: none;
            font-weight: normal;
            font-size: 13px;
          }
        }

        td {
          overflow: hidden;

          //STARS
          .tooltip {
            position: relative;
            display: inline-block;
            color: rgba(0,0,0,0.5);
            width: 130px;
            height: 100%;

            .rate {
              font-size: 16px;

              color: black;
            }

           /* .option{
              margin: 0px 2px;
              display: inline-block;
              border-radius: 100%;
              background-image: url('/img/diagnostic/star.svg');
              color: black;
              width: 20px;
              height: 20px;
              font-weight: bold;
              cursor: pointer;
            }*/
          }

          .tooltip .tooltiptext {
            visibility: hidden;
            opacity: 0;
            width: 110px;
            background-color: white;
            color: #fff;
            text-align: center;
            border-radius: 6px;
            padding: 5px 0;
            position: absolute;
            z-index: 1;
            top: -4px;
            left: 40%;
            margin-left: -35%;
            transition: 0.2s;
          }

          .tooltip .tooltiptext {
            visibility: visible;
            opacity: 100;
          }

          .tooltiptext {
              float: left;
              height: 30px;
              padding: 0 10px;
          }
          .tooltiptext:not(:checked) > input {
              position:absolute;
              top:-9999px;
              display: none;
          }
          .tooltiptext:not(:checked) > label {
              float: right;
              width: 22px;
              overflow: hidden;
              white-space: nowrap;
              cursor: pointer;
              font-size: 27px;
              margin-top: -13px;
              color:#ccc;
          }
          .tooltiptext:not(:checked) > label:before {
              content: '★';
          }
          .tooltiptext > input:checked ~ label:checked, label:checked, .checked {
              color: var(--main_color) !important;
          }
          .tooltiptext:hover > label {
              color: #ccc !important;
          }
          .tooltiptext:not(:checked) > label:hover,
          .tooltiptext:not(:checked) > label:hover ~ label {
              color: var(--main_color) !important;
          }
          .tooltiptext > input:checked + label:hover,
          .tooltiptext > input:checked + label:hover ~ label,
          .tooltiptext > input:checked ~ label:hover,
          .tooltiptext > input:checked ~ label:hover ~ label,
          .tooltiptext > label:hover ~ input:checked ~ label {
              color: var(--main_color);
          }

          input {
            height: 60px;
            text-align: center;
            font-size: 18px;
            appearance: textfield;
            width: 100%;
          }
        }
        .company {
          text-align: left !important;
        }
      }
    }

  .save {
    background-color: #8bc34a;
    width: fit-content;
    margin: 0 auto;
    margin-top: 30px;
    color: white;
    padding: 8px 25px;
    border-radius: 3px;
    font-size: 16px;
    cursor: pointer;
    opacity: 1;
    transition: 0.5s;
    text-transform: uppercase;

    &.hidden {
      display: none;
      opacity: 0;
      height: 0px;
      transition: 0.5s;
    }
  }
</style>

<!-- Unscoped styles for v-html content -->
<style lang="scss">
.competence {
  .which th .description {
    display: block;
    text-transform: none;
    font-weight: normal;
    font-size: 14px;
  }

  .which td.desc .description {
    display: block;
    text-transform: none;
    font-weight: normal;
    font-size: 12px;
    margin-top: 5px;
    color: #999;
  }

  .comparation th .description {
    margin-top: 10px;
    font-size: 12px;
    line-height: 12px;
    display: block;
    color: #666;
    font-weight: lighter;
    text-transform: none;
  }

  .comparation td:first-child .description {
    display: block;
    text-transform: none;
    font-weight: normal;
    font-size: 13px;
  }
}
</style>
